export class FeedbackViewModel {
    public style: string;
    public title: string;
    public detail: string;
    public confirmationStyle: string;
    public confirmationLabel: string;
    public link: string;
}
